var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _ellipse, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 544 334",
    style: {
      enableBackground: "new 0 0 544 334"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n\t.st16{fill:url(#SVGID_17_);}\n\t.st17{fill:url(#SVGID_18_);}\n\t.st18{fill:url(#SVGID_19_);}\n\t.st19{fill:url(#SVGID_20_);}\n\t.st20{fill:#FF8E22;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st22{fill:url(#SVGID_21_);}\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:#FF7E29;}\n\t.st24{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;fill:#FF7E29;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.5416,
    y1: 193.1013,
    x2: 289.7367,
    y2: -3.4051,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5C39"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.3,193c7.2-12.6,53.3-16.7,68-16.3c4.1,0.4,22.7-0.3,27.5-4.7c8.5-9.3-17.1-15.5-14.2-15.4 c7.8,0.3,29.7,1.1,39.2,7.1c4.1,2.6-2,9.4,3,12c11.7,6.2,29,10.6,43.5,18.6c12,6.6,2.1,19.5-3.5,23.9c-13.5,10.5-24,14-47,26.3 c-23,12.3,2,16.2,33,20c31,3.8,55,5.7,66.5,16.2c19.4,17.7-14.5,25.5-87.5,46c-73,20.4-149-8.1-174.5-28.1c-25.5-20,64-46,84.5-55.3 C249.3,233.8,181.3,208.7,190.3,193z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.7405,
    y1: -5.2791,
    x2: 283.2405,
    y2: 21.2209,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.3,330.7c-22.5,2.6-74.5-8-84-11c11.5-22.5,96-16,100.5-15.5s60.5-5.1,81.5,4.4 C346.3,308.6,323.5,325.3,276.3,330.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.8152,
    y1: 335.0651,
    x2: 112.4794,
    y2: 161.7054,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FEDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    style: {
      stopColor: "#FEC809"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      stopColor: "#FF9022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5C39"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152,129h-32.7v42H95.5v-42H0v-17.1L87.9,0h26.5L30.2,108h66.1V70.8h23.1V108H152V129z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.3148,
    y1: 335.065,
    x2: 503.9788,
    y2: 161.7053,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FEDD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    style: {
      stopColor: "#FEC809"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    style: {
      stopColor: "#FF9022"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF5C39"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M543.5,129h-32.7v42H487v-42h-95.5v-17.1L479.4,0h26.5l-84.2,108h66.1V70.8h23.1V108h32.7V129z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.5109,
    y1: 80.5002,
    x2: 248.8799,
    y2: 36.5401,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M211.8,290.9c0-19.5,15.7-35.2,35-35.2s35,15.8,35,35.2c0,0-7.1,4.8-35,4.8S211.8,290.9,211.8,290.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.3463,
    y1: 65.9821,
    x2: 328.7833,
    y2: 56.1441,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.8,276.6c0-4.4,3.4-7.9,7.5-7.9s7.5,3.5,7.5,7.9c0,0-1.5,1.1-7.5,1.1C322.3,277.7,320.8,276.6,320.8,276.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.3463,
    y1: 60.9821,
    x2: 358.7833,
    y2: 51.1441,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M350.8,281.6c0-4.4,3.4-7.9,7.5-7.9s7.5,3.5,7.5,7.9c0,0-1.5,1.1-7.5,1.1C352.3,282.7,350.8,281.6,350.8,281.6z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.2682,
    y1: 93.8422,
    x2: 281.5322,
    y2: 88.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M276.8,245.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C277.7,245.7,276.8,245.1,276.8,245.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.2682,
    y1: 126.8422,
    x2: 314.5322,
    y2: 121.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M309.8,212.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C310.7,212.7,309.8,212.1,309.8,212.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.1403,
    y1: 143.8567,
    x2: 291.9109,
    y2: 140.4968,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M289,193.2c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7c0,0-0.6,0.4-2.7,0.4S289,193.2,289,193.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.2682,
    y1: 47.8422,
    x2: 332.5322,
    y2: 42.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M327.8,291.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C328.7,291.7,327.8,291.1,327.8,291.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.5298,
    y1: 60.077,
    x2: 336.7068,
    y2: 50.111,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M327.8,282.6c0-4.4,3.8-7.9,8.5-7.9c4.7,0,8.5,3.5,8.5,7.9c0,0-1.7,1.1-8.5,1.1S327.8,282.6,327.8,282.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.5298,
    y1: 17.077,
    x2: 272.7068,
    y2: 7.111,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M263.8,325.6c0-4.4,3.8-7.9,8.5-7.9c4.7,0,8.5,3.5,8.5,7.9c0,0-1.7,1.1-8.5,1.1S263.8,325.6,263.8,325.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 338.2682,
    y1: 63.8422,
    x2: 339.5322,
    y2: 58.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M334.8,275.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C335.7,275.7,334.8,275.1,334.8,275.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.6351,
    y1: 56.7215,
    x2: 326.4471,
    y2: 53.4425,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M323.8,280.3c0-1.5,1.1-2.6,2.5-2.6c1.4,0,2.5,1.2,2.5,2.6c0,0-0.5,0.4-2.5,0.4 C324.3,280.7,323.8,280.3,323.8,280.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.6351,
    y1: 14.7215,
    x2: 262.4471,
    y2: 11.4425,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M259.8,322.3c0-1.5,1.1-2.6,2.5-2.6c1.4,0,2.5,1.2,2.5,2.6c0,0-0.5,0.4-2.5,0.4 C260.3,322.7,259.8,322.3,259.8,322.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.6351,
    y1: 57.7215,
    x2: 320.4471,
    y2: 54.4425,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M317.8,279.3c0-1.5,1.1-2.6,2.5-2.6c1.4,0,2.5,1.2,2.5,2.6c0,0-0.5,0.4-2.5,0.4 C318.3,279.7,317.8,279.3,317.8,279.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.6351,
    y1: 13.7215,
    x2: 254.4471,
    y2: 10.4425,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M251.8,323.3c0-1.5,1.1-2.6,2.5-2.6c1.4,0,2.5,1.2,2.5,2.6c0,0-0.5,0.4-2.5,0.4 C252.3,323.7,251.8,323.3,251.8,323.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.2682,
    y1: 54.8422,
    x2: 323.5322,
    y2: 49.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M318.8,284.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C319.7,284.7,318.8,284.1,318.8,284.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.2682,
    y1: 11.8422,
    x2: 259.5322,
    y2: 6.3312,
    gradientTransform: "matrix(1 0 0 -1 0 334.252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M254.8,327.1c0-2.4,2-4.4,4.5-4.4c2.5,0,4.5,2,4.5,4.4c0,0-0.9,0.6-4.5,0.6 C255.7,327.7,254.8,327.1,254.8,327.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 256.8,
    cy: 273.7,
    r: 7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 240.3,
    cy: 275.7,
    rx: 4.5,
    ry: 5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M253.1,284.2c5,0.2,9.9,1.8,12.8,3.1c0.3,0.1,0.4,0.4,0.2,0.7c-0.1,0.3-0.4,0.4-0.7,0.2 c-2.9-1.3-7.6-2.9-12.5-3c-4.8-0.2-9.7,0.9-12.9,4.8c-0.2,0.2-0.5,0.2-0.7,0.1c-0.2-0.2-0.2-0.5-0.1-0.7 C242.9,285.1,248.1,284,253.1,284.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M260.1,269.3c0.2,0.2,0.2,0.5,0,0.7l-6,6c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7l6-6 C259.6,269.1,259.9,269.1,260.1,269.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M243,273.5c0.1,0.1,0.1,0.3,0,0.4l-5,4c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.1-0.3,0-0.4l5-4 C242.7,273.4,242.9,273.4,243,273.5z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M261.2,275.1c-0.1,0.2-0.4,0.3-0.7,0.2l-7.2-4.2c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2l7.2,4.2 C261.3,274.5,261.4,274.9,261.2,275.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M242.8,277.3c-0.1,0.1-0.2,0.2-0.3,0.1l-4.9-2.8c-0.1-0.1-0.2-0.2-0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.1l4.9,2.8 C242.8,277,242.9,277.2,242.8,277.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.7093,
    y1: 18.5901,
    x2: 242.3063,
    y2: 15.2161,
    gradientTransform: "matrix(0.9538 0.3004 0.3004 -0.9538 20.3777 203.5334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M256.7,258.7c1.8,0.6,3.1,1.7,2.9,2.5c-0.2,0.8-1.9,1-3.8,0.4c-1.8-0.6-3.1-1.7-2.9-2.5 C253.2,258.3,254.9,258.1,256.7,258.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M288,156c35,0,64-31,64-70c0-39-29-70-64-70s-64,31-64,70c0,36,24.7,65.3,56.1,69.5 C282.7,155.8,285.3,156,288,156z M288,160c37.6,0,68-33.1,68-74c0-40.9-30.4-74-68-74s-68,33.1-68,74c0,37.8,26,68.9,59.6,73.4 C282.3,159.8,285.2,160,288,160z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M201.5,136.7c17.5,0,31.7-15.1,31.7-33.9c0-18.8-14.2-33.9-31.7-33.9s-31.7,15.1-31.7,33.9 c0,16.1,10.4,29.6,24.4,33.1C196.5,136.6,199,136.7,201.5,136.7z M201.5,137.5c17.9,0,32.5-15.5,32.5-34.7 c0-19.2-14.6-34.7-32.5-34.7S169,83.7,169,102.8c0,16.4,10.7,30.3,25,33.9C196.4,137.4,198.9,137.5,201.5,137.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M200.5,69L200.5,69L200.5,69c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0c-0.4,0-0.9,0.1-1.6,0.2 c-1.4,0.2-3.6,0.6-6.3,1.5c-6.6,2.1-12.3,6.6-16.2,12.6c-3.7,5.5-5.8,12.3-5.8,19.7c0,18.7,13.9,33.7,30.9,33.7 c1.9,0,3.8-0.2,5.6-0.6c5.2-1,10.4,0.2,15.9,2.5c3.4,1.4,7,3.2,10.9,5.1c2.4,1.2,4.8,2.4,7.4,3.6c9.8,4.6,21.3,9,35.7,9.9 c-29.6-6.1-54.9-31.1-54.9-72.2c0-17.4,4.8-33.3,14.9-45.9c8.4-10.5,20.3-18.7,36-23.8c-12.5,2.5-23.6,10-33.9,19 c-5.3,4.7-10.4,9.7-15.4,14.7c-1.2,1.2-2.4,2.4-3.6,3.5c-6.2,6-12.2,11.8-18.4,16.3l-0.3,0.2H200.5L200.5,69z M278.5,13.5 c-22.3,1.3-39.8,18.6-56.2,34.8c-7.4,7.3-14.6,14.4-21.9,19.7c0,0-3.3,0-8.7,1.8c-6.8,2.2-12.7,6.9-16.8,13c-3.8,5.7-6,12.7-6,20.2 c0,19.2,14.3,34.7,31.9,34.7c2,0,3.9-0.2,5.8-0.6c7.9-1.6,16.1,2.5,26.1,7.4c12.9,6.4,28.9,14.3,51.3,13.7c3.3-0.1,6.7-0.3,10.3-0.8 c-3.4,0.2-6.9,0.1-10.3-0.2c-32.3-2.9-61.7-28.2-61.7-72.3c0-33.3,17.8-60.4,56.2-70.5c1.4-0.4,2.8-0.7,4.3-1 C281.5,13.4,280,13.5,278.5,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.16b927deebbdcc2a0101bb4a6edeb7da.svg";
export { ForwardRef as ReactComponent };